import React from 'react';
import { controllerTokens } from '../../../../../tokens/components/Controller/tokens';

const CalendarIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 380 15" width="380" height="15">
    <path
      d="M2 2h12c1.105 0 2 .831 2 1.857v9.286C16 14.169 15.105 15 14 15H2c-1.105 0-2-.831-2-1.857V3.857C0 2.831.895 2 2 2z"
      fill={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M2 2.5c-.836 0-1.5.616-1.5 1.357v9.286c0 .741.664 1.357 1.5 1.357h12c.836 0 1.5-.616 1.5-1.357V3.857c0-.741-.664-1.357-1.5-1.357H2z"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path d="M.778 2.797h14.464V6H.778z" fill={controllerTokens.ContainerFontColorBaseDefault} />
    <path
      d="M3 .5h1c.133 0 .26.053.354.146C4.447.74 4.5.867 4.5 1v2c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146H3c-.133 0-.26-.053-.354-.146C2.553 3.26 2.5 3.133 2.5 3V1c0-.133.053-.26.146-.354C2.74.553 2.867.5 3 .5m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v2c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C11.74.553 11.867.5 12 .5"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M22 2h12c1.105 0 2 .831 2 1.857v9.286C36 14.169 35.105 15 34 15H22c-1.105 0-2-.831-2-1.857V3.857C20 2.831 20.895 2 22 2z"
      fill={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M22 2.5c-.836 0-1.498.614-1.497 1.352l.018 9.265c.001.739.667 1.354 1.504 1.354h12c.835 0 1.497-.614 1.496-1.351l-.017-9.266C35.502 3.115 34.837 2.5 34 2.5H22z"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path d="M20.78 2.795h14.464l.006 3.196H20.786z" fill={controllerTokens.ContainerFontColorBaseDefault} />
    <path
      d="M23 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.993c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C22.74.553 22.867.5 23 .5m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.993c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C31.74.553 31.867.5 32 .5"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M42 2h12c1.105 0 2 .831 2 1.857v9.286C56 14.169 55.105 15 54 15H42c-1.105 0-2-.831-2-1.857V3.857C40 2.831 40.895 2 42 2z"
      fill={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M42 2.5c-.835 0-1.489.606-1.485 1.332l.08 9.193c.006.732.678 1.344 1.517 1.344h12c.835 0 1.489-.606 1.485-1.333l-.08-9.192C55.511 3.111 54.839 2.5 54 2.5H42z"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path d="M40.785 2.789h14.464l.027 3.171H40.812z" fill={controllerTokens.ContainerFontColorBaseDefault} />
    <path
      d="M43 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.967c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C42.74.553 42.867.5 43 .5m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.967c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C51.74.553 51.867.5 52 .5"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M62 2h12c1.105 0 2 .831 2 1.857v9.286C76 14.169 75.105 15 74 15H62c-1.105 0-2-.831-2-1.857V3.857C60 2.831 60.895 2 62 2z"
      fill={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M62 2.5c-.833 0-1.471.589-1.461 1.293l.207 9.043c.015.719.701 1.323 1.544 1.323h12c.833 0 1.471-.589 1.461-1.293l-.207-9.043C75.528 3.104 74.843 2.5 74 2.5H62z"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path d="M60.796 2.776H75.26l.071 3.119H60.867z" fill={controllerTokens.ContainerFontColorBaseDefault} />
    <path
      d="M63 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.915c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C62.74.553 62.867.5 63 .5m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.915c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C71.74.553 71.867.5 72 .5"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M82 2h12c1.105 0 2 .831 2 1.857v9.286C96 14.169 95.105 15 94 15H82c-1.105 0-2-.831-2-1.857V3.857C80 2.831 80.895 2 82 2z"
      fill={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path
      d="M82 2.5c-.831 0-1.441.561-1.42 1.226l.426 8.785c.032.696.741 1.287 1.591 1.287h12c.83 0 1.44-.561 1.42-1.225l-.426-8.785C95.559 3.091 94.85 2.5 94 2.5H82z"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <path d="M80.815 2.754h14.464l.147 3.03H80.962z" fill={controllerTokens.ContainerFontColorBaseDefault} />
    <path
      d="M83 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.825c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C82.74.553 82.867.5 83 .5m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.825c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354C91.74.553 91.867.5 92 .5"
      fill="#ffffff"
      stroke={controllerTokens.ContainerFontColorBaseDefault}
    />
    <g>
      <path
        d="M102 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M102 2.5c-.826 0-1.396.52-1.361 1.127l.748 8.407c.057.663.799 1.236 1.659 1.236h12c.827 0 1.396-.52 1.361-1.127l-.748-8.407c-.056-.664-.798-1.236-1.659-1.236h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M100.842 2.721h14.464l.258 2.901H101.1z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M103 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.693c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.693c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M122 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M122 2.5c-.822 0-1.345.473-1.292 1.015l1.113 7.977c.084.625.864 1.177 1.737 1.177h12c.821 0 1.345-.473 1.292-1.015l-1.113-7.978c-.084-.625-.864-1.176-1.737-1.176h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M120.874 2.685h14.464l.383 2.752h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M123 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.543c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.543c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M142 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M142 2.5c-.818 0-1.3.431-1.232.915l1.437 7.597c.109.591.923 1.123 1.806 1.123h12c.818 0 1.3-.431 1.232-.914l-1.437-7.597c-.109-.592-.923-1.124-1.806-1.124h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M140.901 2.652h14.464l.496 2.621h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M143 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.41c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.41c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M162 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M162 2.5c-.814 0-1.264.398-1.184.836l1.692 7.297c.128.565.968 1.083 1.861 1.083h12c.813 0 1.264-.399 1.183-.837l-1.691-7.297c-.129-.565-.969-1.082-1.861-1.082h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M160.923 2.626h14.464l.584 2.517h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M163 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.305c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.305c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M182 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M182 2.5c-.812 0-1.237.373-1.148.776l1.888 7.067c.143.544 1.004 1.051 1.902 1.051h12c.812 0 1.237-.373 1.147-.776l-1.886-7.067C195.759 3.006 194.898 2.5 194 2.5h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M180.94 2.606h14.464l.651 2.439h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M183 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.224c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.224c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M202 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M202 2.5c-.81 0-1.216.354-1.12.73l2.038 6.891c.154.528 1.03 1.026 1.934 1.026h12c.809 0 1.216-.354 1.119-.73l-2.037-6.891C215.78 2.997 214.903 2.5 214 2.5h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M200.953 2.591h14.464l.702 2.378h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M203 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.163c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.163c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M222 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M222 2.5c-.809 0-1.2.339-1.098.695l2.152 6.755c.163.516 1.052 1.008 1.959 1.008h12c.808 0 1.201-.339 1.098-.695l-2.152-6.755C235.795 2.99 234.907 2.5 234 2.5h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M220.963 2.579h14.464l.742 2.331h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M223 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.116c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.116c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M242 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M242 2.5c-.807 0-1.188.328-1.082.667l2.241 6.652c.17.507 1.068.993 1.978.993h12c.807 0 1.188-.328 1.081-.667l-2.24-6.652c-.17-.508-1.068-.993-1.978-.993h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M240.97 2.57h14.464l.773 2.296h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M243 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.079c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.079c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M262 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M262 2.5c-.807 0-1.179.319-1.069.647l2.308 6.573c.174.5 1.079.982 1.992.982h12c.806 0 1.178-.319 1.068-.647l-2.307-6.573c-.175-.501-1.08-.982-1.992-.982h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M260.976 2.564h14.464l.796 2.268h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M263 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.052c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.052c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M282 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M282 2.5c-.806 0-1.172.313-1.06.631l2.358 6.515c.178.495 1.088.974 2.003.974h12c.805 0 1.171-.313 1.059-.631l-2.357-6.515c-.179-.496-1.089-.974-2.003-.974h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M280.98 2.559h14.464l.813 2.247h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M283 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.031c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.031c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M302 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M302 2.5c-.806 0-1.167.308-1.054.62l2.394 6.473c.181.491 1.095.969 2.01.969h12c.805 0 1.167-.309 1.053-.621l-2.393-6.472c-.182-.493-1.095-.969-2.01-.969h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M300.984 2.555h14.464l.825 2.234h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M303 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.017c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.017c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M322 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M322 2.5c-.805 0-1.163.305-1.049.613l2.417 6.445c.182.489 1.099.965 2.015.965h12c.804 0 1.163-.305 1.048-.613l-2.416-6.445c-.183-.49-1.1-.965-2.015-.965h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M320.986 2.553h14.464l.833 2.224h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M323 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.007c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.007c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M342 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M342 2.5c-.805 0-1.162.304-1.047.609l2.43 6.43c.184.487 1.101.963 2.018.963h12c.804 0 1.162-.304 1.046-.61l-2.429-6.429c-.185-.489-1.102-.963-2.018-.963h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M340.987 2.551h14.464l.837 2.219h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M343 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.002c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1.002c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
    <g>
      <path
        d="M362 2h12c1.105 0 2 .831 2 1.857v9.286c0 1.026-.895 1.857-2 1.857h-12c-1.105 0-2-.831-2-1.857V3.857c0-1.026.895-1.857 2-1.857z"
        fill={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path
        d="M362 2.5c-.805 0-1.161.303-1.046.608l2.434 6.425c.184.487 1.102.962 2.019.962h12c.804 0 1.161-.303 1.045-.608l-2.433-6.425c-.185-.488-1.103-.962-2.019-.962h-12z"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
      <path d="M360.987 2.551h14.464l.839 2.217h-14.464z" fill={controllerTokens.ContainerFontColorBaseDefault} />
      <path
        d="M363 .5h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146m9 0h1c.133 0 .26.053.354.146.093.094.146.221.146.354v1c0 .133-.053.26-.146.354-.094.093-.221.146-.354.146h-1c-.133 0-.26-.053-.354-.146-.093-.094-.146-.221-.146-.354V1c0-.133.053-.26.146-.354.094-.093.221-.146.354-.146"
        fill="#ffffff"
        stroke={controllerTokens.ContainerFontColorBaseDefault}
      />
    </g>
  </svg>
);

export default CalendarIconSVG;
